





































































































































































document.title = "新商家入驻专属通道";
import { Component, Vue } from "vue-property-decorator";
import registerApi from "@/api/register";
import { regExpObj } from "@/utils/regexp";
import { Form, Field, Uploader, Toast, CellGroup, Dialog, Area, Popup, Checkbox, CheckboxGroup } from "vant";
import merchantApi from '@/api/merchant';
import commonApi from '@/api/common';

import area from '@/utils/areaList';
import { encrypt, getUrlParam } from '@/utils/common';
interface BusinessData {
    companyName: string; // 公司名称
    taxpayerId: string; // 纳税人识别号
    legalPersonName: string; // 法人姓名
    enterpriseAlipayAccount: string; // 企业支付宝账号
    contactPerson: string; // 联系人
    contactEmail: string; // 邮箱
    contactPhone: string; // 手机号
    businessAddress: string; // 公司经营地址
    sfExpressAccount: string; // 顺丰月结账号
    address: string; // 公司地址
    billingPhone: string; // 开票电话
    bankName: string; // 开户行
    bankAccountNumber: string; // 银行账号
    frontUrl: string; // 身份证正面图像编号
    backUrl: string; // 身份证背面图像编号
    licenseFrontUrl: string; // 营业执照图像编号
    legalIdHoldingUrl: string; // 法人手持身份证图像编号
    siteVideoUrl: string; // 现场视频图像编号
    settlementCode: string; // 入驻码
    businessCategory: Array<string>; // 类目
    cateList: string; // 类目
    province: string; // 公司地址省
    city: string; // 公司地址市
    district: string; // 公司地址区
    areaCtiy: string; // 公司地址区
}
interface ReasonData {
  data: Array<any>;
}
@Component({
    name: "SettledIn",
    components: {
        [Form.name]: Form,
        [Field.name]: Field,
        [Uploader.name]: Uploader,
        [Dialog.Component.name]: Dialog.Component,
        [Area.name]: Area,
        [Popup.name]: Popup,
        [CheckboxGroup.name]: CheckboxGroup,
        [Checkbox.name]: Checkbox,
    },
})

export default class SettledIn extends Vue {

      reasonList: Array<any> = [];


    $refs!: {
        loginForm: HTMLFormElement;
    };


    private formData: BusinessData = {
        companyName: "",
        taxpayerId: "",
        legalPersonName: "",
        enterpriseAlipayAccount: "",
        contactPerson: "",
        contactEmail: "",
        contactPhone: "",
        businessAddress: "",
        sfExpressAccount: "",
        address: "",
        billingPhone: "",
        bankName: "",
        bankAccountNumber: "",
        frontUrl: "",
        backUrl: "",
        licenseFrontUrl: "",
        legalIdHoldingUrl: "",
        siteVideoUrl: "",
        settlementCode: "",
        businessCategory: [],
        cateList: "",
        areaCtiy: "",
        province: "",
        city: "",
        district: "",
    };


    private show = false
    private cateShow = false
    private areaList = area

    private licenseList = []
    private frontFactList = []
    private backFactList = []
    private legalIdHoldingFactList = []
    private siteVideoFactList = []


    created() {
        console.log('.areaList1', area);
        this.formData.settlementCode = getUrlParam('invitationCode');
        this.formData.companyName = getUrlParam('companyName');
        this.formData.taxpayerId = getUrlParam('taxpayerId');

        console.log('process.env.VUE_APP_ENV', process.env.VUE_APP_DATA_ENV);
        console.log('process.env.NODE_ENV', process.env.NODE_ENV);
        if (!this.isMobile()) {
            window.location.href = process.env.VUE_APP_DATA_ENV === 'production' ? `https://qiaozuji-h5-store.prd.qiaozuji.com/#/merchantH5?invitationCode=${this.formData.settlementCode}&companyName=${this.formData.companyName}&taxpayerId=${this.formData.taxpayerId}` : `https://qiaozuji-h5-store.test.qiaozuji.com/#/merchantH5?invitationCode=${this.formData.settlementCode}&companyName=${this.formData.companyName}&taxpayerId=${this.formData.taxpayerId}`
        }
        this.getCancelReasonList()

    }
    getCancelReasonList() {
        this.$http({
            url: commonApi.qryDictData.url + 'BUSINESS_CATEGORY',
            method: commonApi.qryDictData.method
        }).then((res: ReasonData) => {
            console.log('解约原因列表', res);
            this.reasonList = res.data.map(item => {
                return {
                    label: item.dictLabel,
                    value: item.dictValue,
                }
            });
            console.log('解约原因列表', this.reasonList);

        });
    }


    isMobile() {
        // 如果屏幕宽度小于768px，或者用户代理是移动设备，则认为是手机
        return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }



    cancel(val: string) {
        this.show = false
    }
    confirm(val: Array<{ code: string; name: string }>) {
        console.log(val);
        this.formData.province = val[0].code;
        this.formData.city = val[1].code;
        this.formData.district = val[2].code;
        this.show = false
        this.formData.areaCtiy = val[0].name + '-' + val[1].name + '-' + val[2].name;
    }
    // 校验为空
    validatorTrim(val: string) {
        return !(val.trim() === "");
    }
    validatorUserName(val: string) {
        return regExpObj.userName.test(val);
    }
    validatorPhone(val: string) {
        return regExpObj.telephone.test(val);
    }
    validatorEmail(val: string) {
        return regExpObj.email.test(val);
    }


    SubmitEvent() {

        console.log(this.formData);
        console.log({
            ...this.formData,
            businessCategory: this.formData.businessCategory.join(','),
        });
        this.$refs.loginForm.validate().then(() => {
            if (!this.formData.frontUrl) {
                return this.$toast.fail('请上传法人身份证正面');
            }
            if (!this.formData.backUrl) {
                return this.$toast.fail('请上传法人身份证反面');
            }
            if (!this.formData.licenseFrontUrl) {
                return this.$toast.fail('请上传营业执照');
            }
            if (!this.formData.legalIdHoldingUrl) {
                return this.$toast.fail('请上传法人手持身份证');
            }
            if (!this.formData.siteVideoUrl) {
                return this.$toast.fail('请上传现场视频');
            }
            this.submitRegisterInfo();
        }).catch((err: any) => {
            console.log('err--->', err);
            if (err && err.length) {
                this.$toast.fail(err[0].message);
            }
        })
    }

    // 提交注册信息

    submitRegisterInfo() {
      const data = JSON.parse(JSON.stringify(this.formData));

      data.legalPersonNameEncrypt = encrypt(data.legalPersonName);
      data.contactPersonEncrypt = encrypt(data.contactPerson);
      data.contactPhoneEncrypt = encrypt(data.contactPhone);
      delete data.legalPersonName;
      delete data.contactPerson;
      delete data.contactPhone;

      this.$http({
            url: `${merchantApi.merchantRegister.url}`,
            method: merchantApi.merchantRegister.method,
            params: {
                ...data,
                businessCategory: this.formData.businessCategory.join(','),
            },
        }).then((res: any) => {
            this.$toast.success('提交成功，后台帐号密码将在审核通过后发送到您填写的联系邮箱，请及时查收!');
            setTimeout(() => {
                window.location.reload()
            }, 3000);
        });
    }
    // 法人身份证正面：IDCARD_FRONT

    // 法人身份证反面面：IDCARD_BACK

    // 营业执照：BUSINESS_LICENSE

    // 法人手持身份证：IDCARD_HOLDING

    // 现场视频：LEGAL_VIDEO


    private handleUpload(type: string, fileData: any) {
        console.log('fileData------------->', fileData);


        const formData = new FormData();
        formData.append('file', fileData.file);
        formData.append('documentType', type);

        console.log('handleUpload--formData->', formData);

        this.$http({
            url: merchantApi.merchantUpload.url,
            method: merchantApi.merchantUpload.method,
            isManualDealHttpError: true,
            type: 'file',
            params: formData,
        }).then((res: any) => {
            // 假设接口返回 documentFactId 和 url
            const id = res.data && res.data.documentFactId;
            const url = res.data && res.data.url;
            // 回填到 formData
            switch (type) {
                case 'IDCARD_FRONT':
                    this.formData.frontUrl = url;
                    if (res.data.legalPersonName) {
                        Dialog.alert({
                            title: '标题',
                            message: `当前识别法人姓名为：${res.data.legalPersonName}如有不准确请修改`,
                        }).then(() => {
                            this.formData.legalPersonName = res.data.legalPersonName;
                        });
                    }
                    break;
                case 'IDCARD_BACK':
                    this.formData.backUrl = url;
                    break;
                case 'BUSINESS_LICENSE':
                    this.formData.licenseFrontUrl = url;
                    break;
                case 'IDCARD_HOLDING':
                    this.formData.legalIdHoldingUrl = url;
                    break;
                case 'LEGAL_VIDEO':
                    this.formData.siteVideoUrl = url;
                    break;
            }
        }).catch((err: any) => {
            console.log('err--->', err);
            this.$toast.fail('文件上传失败！');
            switch (type) {
                case 'IDCARD_FRONT':
                    this.frontFactList = []
                    break;
                case 'IDCARD_BACK':
                    this.backFactList = []
                    break;
                case 'BUSINESS_LICENSE':
                    this.licenseList = []
                    break;
                case 'IDCARD_HOLDING':
                    this.legalIdHoldingFactList = [];
                    break;
                case 'LEGAL_VIDEO':
                    this.siteVideoFactList = [];
                    break;
            }
        });
    }



    private afterRead(type: string, fileData: any) {
        const { file } = fileData;

        const isLt5M = file.size / 1024 / 1024 < 5;
        const isLt20M = file.size / 1024 / 1024 < 20;
        const isJPG = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');

        if (isJPG && !isLt5M) {
            this.$toast.fail('上传图片大小不能超过 5MB!');
            switch (type) {
                case 'IDCARD_FRONT':
                    this.frontFactList = []
                    break;
                case 'IDCARD_BACK':
                    this.backFactList = []
                    break;
                case 'BUSINESS_LICENSE':
                    this.licenseList = []
                    break;
                case 'IDCARD_HOLDING':
                    this.legalIdHoldingFactList = [];
                    break;
                case 'LEGAL_VIDEO':
                    this.siteVideoFactList = [];
                    break;
            }
            return; // 如果图片超过5M，直接返回，不继续上传
        }

        if (isVideo && !isLt20M) {
            this.$toast.fail('上传视频大小不能超过 20MB!');
            switch (type) {
                case 'IDCARD_FRONT':
                    this.frontFactList = []
                    break;
                case 'IDCARD_BACK':
                    this.backFactList = []
                    break;
                case 'BUSINESS_LICENSE':
                    this.licenseList = []
                    break;
                case 'IDCARD_HOLDING':
                    this.legalIdHoldingFactList = [];
                    break;
                case 'LEGAL_VIDEO':
                    this.siteVideoFactList = [];
                    break;
            }
            return; // 如果视频超过20M，直接返回，不继续上传
        }

        this.handleUpload(type, fileData);
    }



    onChange(val: string[]) {
        console.log('val', val);
        this.formData.cateList = this.reasonList
            .filter(item => val.includes(item.value))
            .map(item => item.label.trim())
            .join(',');
    }


}
